import { selectVisualTier } from './capability-policy.js';

// Decides whether the deferred 3D runtime is worth loading at all. Pure
// (dependency-injected fetch, no ambient DOM/window reads of its own — see
// runtime-flag.js's convention) so the precedence below is directly unit
// testable without a browser.
//
// There are two independent, intentionally different-latency kill switches:
//   1. capability/device signals (selectVisualTier — no WebGL, prefers-
//      reduced-motion, low power/memory, the build-time
//      VITE_LANDING_VISUALS switch, ...). A poster-tier decision here is
//      FINAL — it is a genuine, build-time-or-device fact and is never
//      overridden by the runtime flag below.
//   2. the runtime kill switch (`fetchRuntimeVisualFlag`, read at request
//      time from /visual-config.json — see runtime-flag.js and
//      netlify/edge-functions/visual-config.js). It is only ever consulted
//      for a tier selectVisualTier judged capable, and can only turn 3D
//      further OFF — it can never turn on a tier already ruled out.
//
// This module exists because the previous inline version of this check in
// main.js let a bad build-time value (VITE_LANDING_VISUALS baked "false" in
// netlify.toml) collapse tier selection to 'poster' and RETURN before the
// runtime-flag fetch ever ran — making the documented "instant, no-redeploy"
// runtime kill switch permanently inert. Keeping the two checks here, in one
// place, with the poster short-circuit ahead of (never after) the runtime
// fetch, is what fixes that.
export async function shouldLoadVisual(capabilities, { fetchRuntimeVisualFlag, fetchImpl, tier } = {}) {
  const resolvedTier = tier ?? selectVisualTier(capabilities);
  if (resolvedTier.id === 'poster') return false;
  return fetchRuntimeVisualFlag({ fetchImpl });
}
